import { useEffect, useState } from "react";
import { subscribeApiLoading } from "../lib/api";

/** Top-of-page loading bar that animates while any API request is in flight. */
export default function GlobalLoadingBar() {
    const [active, setActive] = useState(0);
    useEffect(() => subscribeApiLoading(setActive), []);
    const loading = active > 0;

    return (
        <div
            className="fixed top-0 left-0 right-0 z-[60] h-[3px] pointer-events-none"
            data-testid="global-loading-bar"
            aria-hidden={!loading}
        >
            {loading && (
                <div
                    className="h-full"
                    style={{
                        background: "var(--wl-primary-hex)",
                        animation: "wl-global-stripe 1.1s ease-in-out infinite",
                        boxShadow: "0 0 8px var(--wl-primary-hex)",
                    }}
                />
            )}
            <style>{`@keyframes wl-global-stripe {
                0%   { transform: translateX(-100%); width: 35%; }
                50%  { transform: translateX(180%);  width: 45%; }
                100% { transform: translateX(280%);  width: 35%; }
            }`}</style>
        </div>
    );
}
